interface Props {
  render: (w: number, h: number) => JSX.Element;
  shapeWidth: number;
  shapeHeight: number;
  height?: number;
}

const NodeIcon: React.FC<Props> = ({
  render,
  shapeWidth,
  shapeHeight,
  height = 40,
}) => {
  const aspectRatio = shapeWidth / shapeHeight;
  const width = height * aspectRatio;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${shapeWidth} ${shapeHeight}`}
      preserveAspectRatio="xMidYMid meet"
      fill="none"
    >
      <g strokeLinecap="round" strokeLinejoin="round">
        {render(shapeWidth, shapeHeight)}
      </g>
    </svg>
  );
};
export default NodeIcon;
